import styled, { css } from 'styled-components';

interface LinkProps {
  $hoverGhost?: boolean;
}

export const Link = styled.a<LinkProps>`
  text-decoration: none;
  cursor: pointer;
  color: var(--link-color, ${(props) => props.theme.color.link});

  &:hover {
    text-decoration: underline;
  }

  ${({ $hoverGhost }) =>
    $hoverGhost &&
    css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    `}
`;
